import * as React from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { passwordRegExp } from '../../utils/regExpresions';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import FormHelperText from '@mui/material/FormHelperText';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';


const theme = createTheme();
const getCookie = (name) => {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
export default function SettingsPassword(props) {
  const [passValues, setValues] = React.useState({
    password: '',
    oldPassword: '',
    passwordConfirmation: '',
    showPassword: false,
    showOldPassword: false,
    showPasswordConfirmation: false,
  });
  const handleClickShowPassword = () => {
    setValues({
      ...passValues,
      showPassword: !passValues.showPassword,
    });
  };
  const handleClickShowOldPassword = () => {
    setValues({
      ...passValues,
      showOldPassword: !passValues.showOldPassword,
    });
  };
  const handleClickShowPasswordConfirmation = () => {
    setValues({
      ...passValues,
      showPasswordConfirmation: !passValues.showPasswordConfirmation,
    });
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const handleMouseDownOldPassword = (event) => {
    event.preventDefault();
  };


  return (
    <React.Fragment>
      <CssBaseline />
      <ThemeProvider theme={theme}>
        <Container component="main" maxWidth="lg">
          <Box
            sx={{
              marginTop: 8,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <div style={{ width: "85%", marginBottom: "30px" }}>
              <Typography
                color="textPrimary"
                variant="h5"
                style={{ marginBottom: "0px" }}
              >
                Contraseña
              </Typography>
              <Typography
                color="textPrimary"
                variant="subtitle1"
              >
                Restablecer contraseña
              </Typography>
            </div>
            <Formik
              initialValues={{
                contraseña: '',
                contraseñaAntigua: '',
                confirmarContraseña: '',
              }}

              validationSchema={
                Yup.object().shape({
                  contraseña: Yup.string()
                    .required('Por favor ingrese su contraseña')
                    .matches(passwordRegExp, 'La contraseña debe contener 8 caracteres o mas, Una mayuscula , Una minuscula y un numero. No acepta caracteres especiales'),

                  contraseñaAntigua: Yup.string()
                    .required('Por favor ingrese su contraseña')
                    .matches(passwordRegExp, 'La contraseña debe contener 8 caracteres o mas, Una mayuscula , Una minuscula y un numero. No acepta caracteres especiales'),

                  confirmarContraseña: Yup.string()
                    .oneOf([Yup.ref('contraseña'), null], 'La contraseña tiene que coincidir')
                    .required('Por favor ingrese la confirmacion de su contraseña'),
                })
              }
              onSubmit={async (data, { setFieldError }) => {
                let token = getCookie('asa_hd_auth');
                await fetch(process.env.REACT_APP_API_ROOT + process.env.REACT_APP_API_UPDDATE_USER, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                  body: JSON.stringify({
                    old_password: data.contraseñaAntigua,
                    new_password: data.contraseña,
                  })
                }).then(async (result) => {
                  if (result.ok) {
                    const _result = await result.json();
                  }
                }).catch((error) => {
                })
              }}
            >
              {({
                errors,
                handleSubmit,
                touched,
                values
              }) => (

                <form onSubmit={handleSubmit} style={{ width: "85%" }}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={12}>
                      <FormControl variant="outlined" style={{ width: "100%" }}>
                        <InputLabel error={touched.contraseñaAntigua && errors.contraseñaAntigua ? true : false}>Contraseña actual</InputLabel>
                        <OutlinedInput
                          error={Boolean(touched.contraseñaAntigua && errors.contraseñaAntigua)}
                          id="contraseñaActual"
                          name="contraseñaActual"
                          type={passValues.showOldPassword ? 'text' : 'password'}
                          value={passValues.oldPassword}
                          onChange={(event) => { setValues({ ...passValues, ["oldPassword"]: event.target.value }); values.contraseñaAntigua = event.target.value }}
                          label="Contraseña actual"
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowOldPassword}
                                onMouseDown={handleMouseDownOldPassword}
                                edge="end"
                              >
                                {values.showOldPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                        {touched.contraseñaAntigua && errors.contraseñaAntigua && (
                          <FormHelperText error>
                            {errors.contraseñaAntigua}
                          </FormHelperText>
                        )}
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <FormControl variant="outlined" style={{ width: "100%" }}>
                        <InputLabel error={touched.contraseña && errors.contraseña ? true : false}>Nueva contraseña</InputLabel>
                        <OutlinedInput
                          error={Boolean(touched.contraseña && errors.contraseña)}
                          id="contraseña"
                          name="contraseña"
                          type={passValues.showPassword ? 'text' : 'password'}
                          value={passValues.password}
                          onChange={(event) => { setValues({ ...passValues, ["password"]: event.target.value }); values.contraseña = event.target.value }}
                          label="Nueva contraseña"
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                              >
                                {values.showPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                        {touched.contraseña && errors.contraseña && (
                          <FormHelperText error>
                            {errors.contraseña}
                          </FormHelperText>
                        )}
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl variant="outlined" style={{ width: "100%" }}>
                        <InputLabel error={touched.confirmarContraseña && errors.confirmarContraseña ? true : false}>Confirmar nueva contraseña</InputLabel>
                        <OutlinedInput
                          error={Boolean(touched.confirmarContraseña && errors.confirmarContraseña)}
                          id="confirmarContraseña"
                          name="confirmarContraseña"
                          type={passValues.showPasswordConfirmation ? 'text' : 'password'}
                          value={passValues.passwordConfirmation}
                          onChange={(event) => { setValues({ ...passValues, ["passwordConfirmation"]: event.target.value }); values.confirmarContraseña = event.target.value }}
                          label="Confirmar nueva contraseña"
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPasswordConfirmation}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                              >
                                {passValues.showPasswordConfirmation ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                        {touched.confirmarContraseña && errors.confirmarContraseña && (
                          <FormHelperText error>
                            {errors.confirmarContraseña}
                          </FormHelperText>
                        )}
                      </FormControl>
                    </Grid>
                  </Grid>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                    style={{ color: "#fff", backgroundColor: "#007ccf", marginBottom: "20px", marginTop: "20px" }}
                  >
                    Restablecer Contraseña
                  </Button>
                </form>
              )}
            </Formik>
          </Box>
        </Container>
      </ThemeProvider>
    </React.Fragment>
  );
}
